import { FormGroupState } from "ngrx-forms";

export interface ITfnState {
    form: FormGroupState<TfnModel>;
    dataSaved: boolean;
}

export class TfnModel {
    tfn: string = '';
    tfnAgreement: boolean = false;
}